import React from 'react';

import { Container } from './styles';

interface SeparatorProps {
  type?: 'vertical' | 'horizontal';
  className?: string;
  customHeight?: number;
  customWidth?: number;
  customColor?: string;
}

const Separator: React.FC<SeparatorProps> = ({
  type = 'vertical',
  className,
  customHeight,
  customWidth,
  customColor,
}) => (
  <Container
    className={className || ''}
    type={type}
    customHeight={customHeight || 100}
    customWidth={customWidth || 100}
    customColor={customColor && customColor}
  />
);

export default Separator;
